/* eslint-disable camelcase */
import * as React from 'react';

import Coin from 'components/Coin';
import LayerTrigger from 'components/LayerTrigger';
import Tooltip from 'components/Tooltip';
import Glyph from 'components/Glyph';
import { CoinColor } from 'components/Coin';
import { GlyphName } from '@remind/r101-glyphs';

import { ReachabilityStatus } from 'globalTypes';

export const reachabilityStyles = {
  rich: {
    backgroundColor: 'mascot',
    iconName: 'lightning-bolt',
  },
  poor: {
    backgroundColor: 'percussion',
    iconName: 'ellipses',
  },
  unreachable: {
    backgroundColor: 'percussion',
    iconName: 'close',
  },
};

type ReachabilityAction = {
  type: 'link' | 'add_number';
  text: string;
  link?: string;
};

export type ReachabilityInfo = {
  __typename: 'ReachabilityInfo';
  status: ReachabilityStatus;
  reason_short?: string;
  reasonShort?: string;
  reason_long?: string;
  reasonLong?: string;
  action?: ReachabilityAction;
};

type Props = {
  reachability: ReachabilityInfo;
};

function ReachabilityBadge(props: Props) {
  const { reachability } = props;

  if (!reachability) {
    return null;
  }

  const { status, reasonShort, reason_short } = reachability;

  const styles = reachabilityStyles[status];

  if (!styles) {
    console.error('ReachabilityBadge tried to get styles for nonexistent status');
    return null;
  }

  return (
    <Coin color={styles.backgroundColor as CoinColor} size="xsmall">
      <LayerTrigger layer={<Tooltip>{reasonShort || reason_short}</Tooltip>} placement="top">
        <Glyph name={styles.iconName as GlyphName} color="whiteout" solo />
      </LayerTrigger>
    </Coin>
  );
}

export default ReachabilityBadge;
